var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReplyToAll = function SvgReplyToAll(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 18 16.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.61 13.593a.61.61 0 0 1-.452-.193L.188 7.254a.67.67 0 0 1 0-.931L6.157.177a.63.63 0 0 1 .889.016.67.67 0 0 1 .015.914L1.543 6.788l5.52 5.68a.668.668 0 0 1-.208 1.075.6.6 0 0 1-.245.05m3.625 0a.61.61 0 0 1-.452-.193L3.812 7.254a.67.67 0 0 1 0-.931L9.782.177a.63.63 0 0 1 .89.016.67.67 0 0 1 .015.914L5.84 6.097h5.034c1.298 0 3.068.504 4.516 1.947 1.46 1.456 2.528 3.801 2.528 7.361a.7.7 0 1 1-1.4 0c0-3.27-.972-5.228-2.117-6.37-1.157-1.153-2.559-1.539-3.527-1.539H5.856l4.831 4.973a.668.668 0 0 1-.207 1.074.6.6 0 0 1-.245.05",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReplyToAll);
export default ForwardRef;